import useRouter from 'app/hooks/useRouter';
import Navigation from 'assets/components/navigation/Navigation';
import ThemeNavigationSidebar from 'assets/components/navigation/themes/Theme.Navigation.Sidebar';

export default function AppNavigation() {
  const { routes, homeRoute } = useRouter();

  return <Navigation class={ThemeNavigationSidebar} routes={routes} homePage={homeRoute?.path ?? '/'} />;
}
